import { render, staticRenderFns } from "./expertlist.vue?vue&type=template&id=29123834&scoped=true"
import script from "./expertlist.vue?vue&type=script&lang=js"
export * from "./expertlist.vue?vue&type=script&lang=js"
import style0 from "./expertlist.vue?vue&type=style&index=0&id=29123834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29123834",
  null
  
)

export default component.exports